import colors from 'theme/colors';

/**
 * Order of colors for visuals established in one place to allow
 * for consistency within line graph and buttons
 *
 * Note: Repeats for safety (out of bounds error potential)
 *
 * Order: yellow, red, blue, purple, pink, teal, blue
 */
export default [
  colors.contractYellow,
  colors.contractWithoutOptionsBlue,
  colors.batna1Green,
  colors.batna2Royal,
  colors.batna3Teal,
  colors.batna4Violet,
  colors.batna5Red,
  colors.batna6Brown,

  colors.contractYellow,
  colors.contractWithoutOptionsBlue,
  colors.batna1Green,
  colors.batna2Royal,
  colors.batna3Teal,
  colors.batna4Violet,
  colors.batna5Red,
  colors.batna6Brown,

  colors.contractYellow,
  colors.contractWithoutOptionsBlue,
  colors.batna1Green,
  colors.batna2Royal,
  colors.batna3Teal,
  colors.batna4Violet,
  colors.batna5Red,
  colors.batna6Brown,
];
